// @flow

export default {
  INTERNET_EXPLORER: 'ie11'
};
